import axiosConfig from "./axiosConfig";

const templatesAPI = {};

templatesAPI.getTemplates = () => axiosConfig.get(`/api/setlist-templates/`);
templatesAPI.get = (id) => axiosConfig.get(`/api/setlist-templates/${id}/`);
templatesAPI.createTemplate = (data) =>
  axiosConfig.post(`/api/setlist-templates/`, data);
templatesAPI.patchTemplate = (id, data) =>
  axiosConfig.patch(`/api/setlist-templates/${id}/`, data);
templatesAPI.deleteTemplate = (id) =>
  axiosConfig.delete(`/api/setlist-templates/${id}/`);
templatesAPI.setDefault = (id) =>
  axiosConfig.post(`/api/setlist-templates/${id}/set-default/`);

export default templatesAPI;
